import React, { useState } from 'react';
import { auth, googleProvider } from '../firebase';
import { signInWithPopup, OAuthProvider } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo';

const Login = ({ onLogin }) => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      console.log('Current user ID:', result.user.uid);
      if (onLogin) {
        onLogin(result.user);
      }
      navigate('/');
    } catch (error) {
      console.error('Detailed login error:', error);
      setError('Failed to login. Please try again.');
    }
  };

  const handleAppleLogin = async () => {
    try {
      console.log('Starting Apple login process...');
      const provider = new OAuthProvider('apple.com');
      provider.addScope('email');
      provider.addScope('name');
      
      console.log('Apple provider configuration:', provider);
      
      const result = await signInWithPopup(auth, provider);
      console.log('Apple login successful:', result);
      
      if (onLogin) {
        onLogin(result.user);
      }
      navigate('/');
    } catch (error) {
      console.error('Detailed Apple login error:', {
        code: error.code,
        message: error.message,
        customData: error.customData,
        serverResponse: error.customData?._tokenResponse
      });
      setError(`Failed to login with Apple: ${error.message}`);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-white to-green-50 p-4">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <div className="flex flex-col items-center">
          <Logo className="w-24 h-24 mb-6" />
          <h1 className="text-3xl font-bold text-[#00B140] mb-2">
            Going Green Cards
          </h1>
          <p className="text-gray-600 text-center mb-8">
            Remember everyone!
          </p>
        </div>

        <button
          onClick={handleGoogleLogin}
          className="w-full bg-white border border-gray-300 text-gray-700 py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition duration-200 flex items-center justify-center gap-3"
        >
          <svg viewBox="0 0 48 48" className="w-6 h-6 mr-2">
            <path
              fill="#EA4335"
              d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
            />
            <path
              fill="#4285F4"
              d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
            />
            <path
              fill="#FBBC05"
              d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
            />
            <path
              fill="#34A853"
              d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
            />
            <path fill="none" d="M0 0h48v48H0z" />
          </svg>
          Sign in with Google
        </button>

        <button
          onClick={handleAppleLogin}
          className="w-full bg-black text-white py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition duration-200 flex items-center justify-center gap-3 mt-4"
        >
          <svg viewBox="0 0 24 24" className="w-6 h-6">
            <path
              fill="currentColor"
              d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
            />
          </svg>
          <span>Sign in with Apple</span>
        </button>

        {error && (
          <p className="text-red-500 text-center mt-4">{error}</p>
        )}
      </div>
    </div>
  );
};

export default Login;